module.exports = __webpack_public_path__ + "img/unicaja.f1107a9e.png";